import { useContext, useState } from "react";
import { Logo, ViewContext, useNavigate } from "@/components/lib";
import { useForm } from "react-hook-form";
import Styles from "@/css/mainStyles";
import axios from "axios";

export function VerifyEmail() {
  const viewContext = useContext<any>(ViewContext);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({});

  const onSubmit = async (data: any) => {
    setLoading(true);
    try {
      await axios({
        method: "get",
        url: "/api/otp/" + data.code
      });
      navigate("/signup/application-review");
    } catch (error) {
      console.error(error);
      viewContext.notification.show(error.message, "error");
    } finally {
      setLoading(false);
    }
  };

  const resendCode = async () => {
    try {
      await axios({
        method: "post",
        url: "/api/otp",
        data: { email: localStorage.getItem("emailghs") }
      });
      viewContext.notification.show("Code resent", "success");
    } catch (error) {
      console.error(error);
      viewContext.notification.show(error.message, "error");
    }
  };

  return (
    <div className="flex flex-col justify-center h-screen p-8 md:px-32 text-left lg:w-1/2">
      <Logo className="w-80 lg:w-96 mx-auto my-5 lg:mb-12" />
      <h1 className="font-bold text-2xl lg:text-4xl">Verify your Email</h1>
      <h2 className="mt-3 text-xl">
        We just sent a 6-digit code to your email, enter it below.
      </h2>
      <form
        className="flex flex-col gap-6 mt-7"
        onSubmit={handleSubmit(onSubmit)}
      >
        <div className="flex flex-col flex-1 w-full">
          <label className={Styles.label}>Code</label>
          <input
            placeholder="Enter Code"
            type="text"
            className={Styles.input}
            {...register("code", { required: true })}
            style={errors.code && { border: "1px solid red" }}
          />
          {errors.code && <p className={Styles.error}>Code is required</p>}
        </div>
        <input
          type="submit"
          value={loading ? "Loading..." : "Continue"}
          disabled={loading}
          className={Styles.submitButton}
        />
        <button
          type="button"
          onClick={resendCode}
          disabled={loading}
          className="w-fit lg:text-2xl mx-auto"
        >
          Resend Code
        </button>
      </form>
    </div>
  );
}
